// Export specific items to avoid conflicts
export { 
  goalsSchema,
  budgetSchema,
  timelineSchema,
  channelsSchema as clientChannelsSchema,
  uploadsSchema as clientUploadsSchema,
  clientOnboardingSchema,
  GOAL_OPTIONS as CLIENT_GOAL_OPTIONS,
  BUDGET_OPTIONS as CLIENT_BUDGET_OPTIONS,
  URGENCY_OPTIONS as CLIENT_URGENCY_OPTIONS,
  CHANNEL_OPTIONS as CLIENT_CHANNEL_OPTIONS
} from "./clientOnboardingSchema";

export type { ClientOnboardingData } from "./clientOnboardingSchema";

export { 
  basicsSchema,
  capacitySchema,
  industriesSchema,
  channelsSchema as proChannelsSchema,
  budgetsSchema,
  uploadsSchema as proUploadsSchema,
  linksSchema,
  proOnboardingSchema,
  INDUSTRY_OPTIONS as PRO_INDUSTRY_OPTIONS,
  CHANNEL_OPTIONS as PRO_CHANNEL_OPTIONS,
  BUDGET_OPTIONS as PRO_BUDGET_OPTIONS
} from "./proOnboardingSchema";

export type { ProOnboardingData } from "./proOnboardingSchema";

export * from "./storage";
